import { controls,grouped } from "../controls";
const manual_inspections = {
label: "Manual Inspections",
pageLabel: "Manual Inspections",starting: true,url: "autogen",
submitLogic:{allowPartialSubmit:true,doubleConfirm:'irreversible',submitText:'finalsubmit',},
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Client"}),
...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "ManualInspection-client-client_code",fastpath: "clients"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "ManualInspection-client-client_display"}),
...controls.displayText({ tab: "filter", label: "Branch"}),
...controls.oc({ tab: "filter",length:4, c: "Branch", placeHolder: "Branch Code", name: "ManualInspection-branch-branch_code",fastpath: "branches"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "ManualInspection-branch-branch_display"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Branch",star:false,style:{textAlign:'left'},width:'col-sm-1'}),
...controls.oc({ tab: "general", length:4, c: "Branch", placeHolder: "Branch Code", name: "branch_code",fastpath: "branches" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display"}),
...controls.checkBox({ tab: "general", label: "Acknowledge",default:false, name: "acknowledge",parents:[{"name": "branch_display", "match": "in", "value": ["khasdkhakue"]}] }),

...controls.flatFootersGenerator({tab:'general',components:[
...controls.showData({tab: "general", displaytype: "capital", data: "mi_observation_type_display",width:"col-sm-10",style:{marginBottom:5},dheight:'multiline',prepend:1}),
...controls.autoComplete({tab: "general", name: "inspection_status_code", width: "col-sm-2",controlType: "InspectionStatus",width:"col-sm-2",isRequired:true}),
...controls.text({ tab: "general",  placeHolder: "Remarks", name: "remark",width:"col-sm-4",maxlength:500,width:"col-sm-8",isRequired:true}),
...controls.magicDateLabel({ tab: "general", label: "Complete By",target: "complete_by",star:false,parents:[{"name": "inspection_status_code", "match": "in", "value": ["Incomplete", "In Progress", "Not Started"]}]}),
...controls.magicDate({ tab: "general", name: "complete_by", dateType: "ontype",parents:[{"name": "inspection_status_code", "match": "in", "value": ["Incomplete", "In Progress", "Not Started"]}],minDate:'n',maxDate:'1 months from now',isRequired:true }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
],
 foot:'mi_observations',pivot_fastpath:'mi_observation_types',
 pivotat:'mi_observation_type_code'}),
]
,history:{
perPage: 10,
reportHeader: "Manual Inspections",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Client",accessor: "ManualInspection-client-client_display",},
{Header: "Branch",accessor: "ManualInspection-branch-branch_display",},
{Header: "Updatedat",accessor: "updatedat",type:'date'},
]}};
export default manual_inspections;